import React, { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import estilos from './DatosGeneralesComponent.module.css'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import ModalHistorialCambiosComponent from '../ModalHistorialCambiosComponent';


function PersonasAutorizadasComponent(props) {

    const dispatch = useDispatch()

    const [personaautoriazadaparatramites, setPersonaAutorizada] = React.useState(props?.data?.personaautoriazadaparatramites?.toUpperCase())
    const [telefonopersona, setTelefono] = React.useState(props?.data?.telefonopersona)
    const [correoelectronicopersona, setCorreoElectronico] = React.useState(props?.data?.correoelectronicopersona?.toLowerCase())

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState(props?.data?.representantesautorizadosclientehistorial);
    const handleModalHistorial = () => {
        setDataHistorial(props?.data?.representantesautorizadosclientehistorial)
        setOpenModalHistorial(true)
    }

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <div style={{ border: '2px solid white', position: 'relative' }}>
                    <div className={`${estilos.tarjetaContacto}`} style={props?.data?.isbaja ? { border: '4px solid #DC3545' } : { border: '4px solid #8ABE3E' }}>
                        <div>
                            {props?.data?.isbaja == false &&
                                <div style={{ display: 'flex', justifyContent: 'end' }} >
                                    <Tooltip title="Ver historial de cambios">
                                        <IconButton size="large" sx={{ p: 1 }} onClick={() => { handleModalHistorial() }}>
                                            <HistoryRoundedIcon fontSize="inherit" sx={{ color: '#2B2B2B' }} />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            }
                            {props?.data?.isbaja == true &&
                                <div style={{ display: 'flex', justifyContent: 'end' }} >
                                    <IconButton size="large" sx={{ p: 1 }} disableFocusRipple disableRipple disabled >
                                        <HistoryRoundedIcon fontSize="inherit" sx={{ color: 'white' }} />
                                    </IconButton>
                                </div>
                            }
                            <p style={{ marginTop: '3%', fontWeight: 'bold' }}> {props?.data?.isbaja ? 'INACTIVO' : 'ACTIVO'} </p>
                            <div className='row'>
                                <div className='col-2 col-md-2 mt-1 text-end'>
                                    <p><PersonRoundedIcon /></p>
                                </div>
                                <div className='col-10 col-md-10 mt-1 pe-5 text-start'>
                                    {personaautoriazadaparatramites}
                                </div>
                                <div className='col-2 col-md-2 mt-1 text-end'>
                                    <p><CallRoundedIcon /></p>
                                </div>
                                <div className='col-10 col-md-10 mt-1 pe-5 text-start'>
                                    {telefonopersona}
                                </div>
                                <div className='col-2 col-md-2 mt-1 text-end'>
                                    <p><EmailRoundedIcon /></p>
                                </div>
                                <div className='col-10 col-md-10 mt-1 pe-5 text-start'>
                                    {correoelectronicopersona}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${estilos.circuloContacto}`} style={props?.data?.isbaja ? { border: '4px solid #DC3545', backgroundColor: '#DC3545' } : { border: '4px solid #8ABE3E', backgroundColor: '#8ABE3E' }}>
                        <PeopleAltRoundedIcon fontSize="large" style={{ fill: 'white' }} />
                    </div>
                </div>
            </ThemeProvider>

            {openModalHistorial && <ModalHistorialCambiosComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} apartado={"Persona autorizada"} />}
        </Fragment >
    )
}

export default PersonasAutorizadasComponent